import generateCountdownString from './generateCountdownString';

export default generateCountdownString;
